<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";
import { VMoney } from "v-money";
import Password from "@/components/widgets/input-password";

export default {
  locales: {
    pt: {
      'Transfer': 'Transferir',
      'The wallet is invalid.': 'A carteira é inválida.',
      'Enter a transfer amount.': 'Digite o valor da transferência.',
      'The minimum transfer amount is R$ 1,00': 'O valor mínimo para transferência é de R$ 1,00.',
      'You do not have enough balance to transfer.': 'Você não possui saldo suficiente para essa transferência.',
      'Your security password is incorrect.': 'Sua senha de segurança está incorreta.',
      'Your transfer was successful.': 'Sua transferência foi realizada com sucesso.',
      'From wallet': 'Da carteira',
      'From wallet is required.': 'A carteira é obrigatória.',
      'Wallet balance': 'Saldo da carteira',
      'To wallet': 'Para carteira',
      'To wallet is required.': 'A carteira é obrigatória.',
      'Transfer amount': 'Valor da transferência',
      'Amount is required.': 'O valor é obrigatório',
      'Security password': 'Senha de segurança',
    },
    es: {
      'Transfer': 'Transferir',
      'The wallet is invalid.': 'A carteira é inválida.',
      'Enter a transfer amount.': 'Digite o valor da transferência.',
      'The minimum transfer amount is R$ 1,00': 'O valor mínimo para transferência é de R$ 1,00.',
      'You do not have enough balance to transfer.': 'Você não possui saldo suficiente para essa transferência.',
      'Your security password is incorrect.': 'Sua senha de segurança está incorreta.',
      'Your transfer was successful.': 'Su transferencia se ha realizado correctamente.',
      'From wallet': 'De la cartera',
      'From wallet is required.': 'La cartera se requiere.',
      'Wallet balance': 'Saldo de la cartera',
      'To wallet': 'Para la cartera',
      'To wallet is required.': 'La cartera se requiere.',
      'Transfer amount': 'Valor da transferencia',
      'Amount is required.': 'El valor se requiere.',
      'Security password': 'Contraseña de seguridad',
    }
  },
  components: { Layout, Password },
  data() {
    return {
      loading: false,
      success: false,

      wallet: {
        from: [],
        to: []
      },
      from: 'network',
      balance: '0.00',
      to: 'network',
      email: '',
      value: '',
      password: '',

      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2
      },
    };
  },
  directives: { money: VMoney },
  validations: {
    from: { required },
    to: { required },
    email: { required },
    value: { required },
    password: { required },
  },
  methods: {
    getTransfer() {
      api
        .get('wallet/transfer')
        .then(response => {
          if (response.data.status == 'success') {
            this.wallet.from = response.data.from
            this.from = 'network'
            this.wallet.to = response.data.to
            this.to = 'network'
          }
        })
    },
    getBalance(wallet) {
      this.balance = '0.00'
      api
        .get('wallet/balance/' + wallet)
        .then(response => {
          if (response.data.status == 'success') {
            this.balance = this.$options.filters.currency(response.data.balance.available);
          }
        })
    },
    getEmail() {
      if (this.email) {
        api
          .post('wallet/transfer/user', {
            email: this.email,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.$toast.success(response.data.message)
            } else {
              this.$toast.error(response.data.message)
            }
          })
      }
    },
    transterSubmit() {
      this.loading = true
      this.$v.$touch();

      if (this.value) {
        api
          .post('wallet/transfer', {
            from: this.from,
            to: this.to,
            email: this.email,
            value: this.value,
            password: this.password,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.success = true
              this.email = ''
              this.value = '0.00'
              this.password = ''
              this.$v.$reset()

              this.$toast.success(this.t(response.data.message))
            } else {
              this.password = ''
              this.$v.$reset()

              this.$toast.error(this.t(response.data.message))
            }

            this.loading = false
          })
      }
    }
  },
  mounted() {
    this.getTransfer()
    this.getBalance(this.from)
  },
  watch: {
    from(wallet) {
      if (wallet) {
        this.getBalance(wallet)
      } else {
        this.balance = '0.00'
      }
    }
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/wallet/extract">Financeiro</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">{{ t('Transfer') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Transfer') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-body p-4">
            <div v-if="success" class="text-center-sm">
              {{ t('Your transfer was successful.') }}
            </div>
            <b-form v-else class="p-3" @submit.prevent="transterSubmit">
              <b-form-group id="balance" :label="t('Wallet balance')" label-for="balance">
                <b-form-input id="balance" v-model="balance" type="text" disabled></b-form-input>
              </b-form-group>
              <b-form-group id="email" :label="t('Email')" label-for="email">
                <b-form-input id="email" v-model="email" type="text" :class="{ 'is-invalid': $v.email.$error }" v-on:blur="getEmail()"
                  autocomplete="off"></b-form-input>
                <div v-if="$v.email.$error" class="invalid-feedback">
                  <span v-if="!$v.email.required">{{ t('Email is required.') }}</span>
                </div>
              </b-form-group>
              <b-form-group id="value" :label="t('Transfer amount')" label-for="value">
                <b-form-input id="value" v-model="value" v-money="money" type="text" inputmode="decimal" :class="{ 'is-invalid': $v.value.$error }"></b-form-input>
                <div v-if="$v.value.$error" class="invalid-feedback">
                  <span v-if="!$v.value.required">{{ t('Amount is required.') }}</span>
                </div>
              </b-form-group>
              <b-form-group id="password" :label="t('Security password')" label-for="password">
                <Password v-model="password" :v="$v.password"></Password>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="loading == true || !this.email || this.value === '0.00' || !this.password" type="submit" variant="default">
                  {{ t('Transfer') }}
                  <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>